import { createRouter, createWebHistory } from 'vue-router';

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'game',
      component: () => import('@/pages/DailyGamePage.vue'),
    },
    {
      // Beta Lab (closed beta §8): a distinct mode, not a hidden option on the daily game.
      // Authorization is server-side; this route only decides which page renders.
      path: '/beta',
      name: 'beta',
      component: () => import('@/pages/BetaLabPage.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/pages/NotFoundPage.vue'),
    },
  ],
});
